// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   Button,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   TextField,
// // // } from "@mui/material";
// // // import { getAllVideos, createVideo, updateVideo, deleteVideo } from "../../../services/adminService";

// // // const VideoManagement = () => {
// // //   const [videos, setVideos] = useState([]);
// // //   const [openDialog, setOpenDialog] = useState(false);
// // //   const [editingVideo, setEditingVideo] = useState(null);
// // //   const [formData, setFormData] = useState({ title: "", videoUrl: "", category: "", subCategory: "" });

// // //   // Fetch all videos
// // //   const fetchVideos = async () => {
// // //     try {
// // //       const data = await getAllVideos();
// // //       setVideos(data.data);
// // //     } catch (error) {
// // //       console.error("Error fetching videos:", error);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchVideos();
// // //   }, []);

// // //   const handleOpenDialog = (video = null) => {
// // //     setEditingVideo(video);
// // //     setFormData(video ? { ...video } : { title: "", videoUrl: "", category: "", subCategory: "" });
// // //     setOpenDialog(true);
// // //   };

// // //   const handleCloseDialog = () => {
// // //     setOpenDialog(false);
// // //     setEditingVideo(null);
// // //     setFormData({ title: "", videoUrl: "", category: "", subCategory: "" });
// // //   };

// // //   const handleSubmit = async () => {
// // //     try {
// // //       if (editingVideo) {
// // //         await updateVideo(editingVideo._id, formData);
// // //       } else {
// // //         await createVideo(formData);
// // //       }
// // //       fetchVideos();
// // //       handleCloseDialog();
// // //     } catch (error) {
// // //       console.error("Error saving video:", error);
// // //     }
// // //   };

// // //   const handleDelete = async (id) => {
// // //     try {
// // //       await deleteVideo(id);
// // //       fetchVideos();
// // //     } catch (error) {
// // //       console.error("Error deleting video:", error);
// // //     }
// // //   };

// // //   return (
// // //     <Paper style={{ padding: "1rem" }}>
// // //       <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>Add Video</Button>
// // //       <TableContainer>
// // //         <Table>
// // //           <TableHead>
// // //             <TableRow>
// // //               <TableCell>Title</TableCell>
// // //               <TableCell>Video URL</TableCell>
// // //               <TableCell>Category</TableCell>
// // //               <TableCell>SubCategory</TableCell>
// // //               <TableCell>Actions</TableCell>
// // //             </TableRow>
// // //           </TableHead>
// // //           <TableBody>
// // //             {videos.map((video) => (
// // //               <TableRow key={video._id}>
// // //                 <TableCell>{video.title}</TableCell>
// // //                 <TableCell>{video.videoUrl}</TableCell>
// // //                 <TableCell>{video.category_name}</TableCell>
// // //                 <TableCell>{video.subCategory_name}</TableCell>
// // //                 <TableCell>
// // //                   <Button variant="outlined" color="primary" onClick={() => handleOpenDialog(video)}>Edit</Button>
// // //                   <Button variant="outlined" color="secondary" onClick={() => handleDelete(video._id)}>Delete</Button>
// // //                 </TableCell>
// // //               </TableRow>
// // //             ))}
// // //           </TableBody>
// // //         </Table>
// // //       </TableContainer>

// // //       <Dialog open={openDialog} onClose={handleCloseDialog}>
// // //         <DialogTitle>{editingVideo ? "Edit Video" : "Add Video"}</DialogTitle>
// // //         <DialogContent>
// // //           <TextField
// // //             label="Title"
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.title}
// // //             onChange={(e) => setFormData({ ...formData, title: e.target.value })}
// // //           />
// // //           <TextField
// // //             label="Video URL"
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.videoUrl}
// // //             onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
// // //           />
// // //           <TextField
// // //             label="Category"
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.category}
// // //             onChange={(e) => setFormData({ ...formData, category: e.target.value })}
// // //           />
// // //           <TextField
// // //             label="SubCategory"
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.subCategory}
// // //             onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
// // //           />
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleCloseDialog}>Cancel</Button>
// // //           <Button onClick={handleSubmit} variant="contained" color="primary">{editingVideo ? "Update" : "Create"}</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Paper>
// // //   );
// // // };

// // // export default VideoManagement;

// // import React, { useState, useEffect } from "react";
// // import {
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   Button,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   MenuItem
// // } from "@mui/material";
// // import { getAllVideos, createVideo, updateVideo, deleteVideo } from "../../../services/adminService";
// // import { getCategories, getSubcategories } from "../../../services/apiService";

// // const VideoManagement = () => {
// //   const [videos, setVideos] = useState([]);
// //   const [openDialog, setOpenDialog] = useState(false);
// //   const [editingVideo, setEditingVideo] = useState(null);
// //   const [formData, setFormData] = useState({ title: "", videoUrl: "", category: "", subCategory: "" });
// //   const [categories, setCategories] = useState([]);
// //   const [subcategories, setSubcategories] = useState([]);

// //   // Fetch videos
// //   const fetchVideos = async () => {
// //     try {
// //       const data = await getAllVideos();
// //       setVideos(data.data);
// //     } catch (error) {
// //       console.error("Error fetching videos:", error);
// //     }
// //   };

// //   // Load categories on mount
// //   useEffect(() => {
// //     fetchVideos();
// //     const loadCategories = async () => {
// //       try {
// //         const res = await getCategories();
// //         setCategories(res.data);
// //       } catch (error) {
// //         console.error("Error loading categories:", error);
// //       }
// //     };
// //     loadCategories();
// //   }, []);

// //   // Load subcategories whenever category changes
// //   useEffect(() => {
// //     if (!formData.category) {
// //       setSubcategories([]);
// //       return;
// //     }
// //     const loadSubcategories = async () => {
// //       try {
// //         const res = await getSubcategories(formData.category);
// //         setSubcategories(res.data);
// //       } catch (error) {
// //         console.error("Error loading subcategories:", error);
// //         setSubcategories([]);
// //       }
// //     };
// //     loadSubcategories();
// //   }, [formData.category]);

// //   const handleOpenDialog = (video = null) => {
// //     setEditingVideo(video);
// //     setFormData(video ? { ...video } : { title: "", videoUrl: "", category: "", subCategory: "" });
// //     setOpenDialog(true);
// //   };

// //   const handleCloseDialog = () => {
// //     setOpenDialog(false);
// //     setEditingVideo(null);
// //     setFormData({ title: "", videoUrl: "", category: "", subCategory: "" });
// //     setSubcategories([]);
// //   };

// //   const handleSubmit = async () => {
// //     try {
// //       if (editingVideo) {
// //         await updateVideo(editingVideo._id, formData);
// //       } else {
// //         await createVideo(formData);
// //       }
// //       fetchVideos();
// //       handleCloseDialog();
// //     } catch (error) {
// //       console.error("Error saving video:", error);
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     try {
// //       await deleteVideo(id);
// //       fetchVideos();
// //     } catch (error) {
// //       console.error("Error deleting video:", error);
// //     }
// //   };

// //   return (
// //     <Paper style={{ padding: "1rem" }}>
// //       <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>Add Video</Button>
// //       <TableContainer>
// //         <Table>
// //           <TableHead>
// //             <TableRow>
// //               <TableCell>Title</TableCell>
// //               <TableCell>Video URL</TableCell>
// //               <TableCell>Category</TableCell>
// //               <TableCell>SubCategory</TableCell>
// //               <TableCell>Actions</TableCell>
// //             </TableRow>
// //           </TableHead>
// //           <TableBody>
// //             {videos.map((video) => (
// //               <TableRow key={video._id}>
// //                 <TableCell>{video.title}</TableCell>
// //                 <TableCell>{video.videoUrl}</TableCell>
// //                 <TableCell>{video.category_name}</TableCell>
// //                 <TableCell>{video.subCategory_name}</TableCell>
// //                 <TableCell>
// //                   <Button variant="outlined" color="primary" onClick={() => handleOpenDialog(video)}>Edit</Button>
// //                   <Button variant="outlined" color="secondary" onClick={() => handleDelete(video._id)}>Delete</Button>
// //                 </TableCell>
// //               </TableRow>
// //             ))}
// //           </TableBody>
// //         </Table>
// //       </TableContainer>

// //       <Dialog open={openDialog} onClose={handleCloseDialog}>
// //         <DialogTitle>{editingVideo ? "Edit Video" : "Add Video"}</DialogTitle>
// //         <DialogContent>
// //           <TextField
// //             label="Title"
// //             fullWidth
// //             margin="dense"
// //             value={formData.title}
// //             onChange={(e) => setFormData({ ...formData, title: e.target.value })}
// //           />
// //           <TextField
// //             label="Video URL"
// //             fullWidth
// //             margin="dense"
// //             value={formData.videoUrl}
// //             onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
// //           />
// //           <TextField
// //             label="Category"
// //             select
// //             fullWidth
// //             margin="dense"
// //             value={formData.category}
// //             onChange={(e) => setFormData({ ...formData, category: e.target.value })}
// //           >
// //             {categories.map(cat => (
// //               <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
// //             ))}
// //           </TextField>
// //           <TextField
// //             label="SubCategory"
// //             select
// //             fullWidth
// //             margin="dense"
// //             value={formData.subCategory}
// //             onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
// //             disabled={!formData.category}
// //           >
// //             {subcategories.map(sub => (
// //               <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>
// //             ))}
// //           </TextField>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleCloseDialog}>Cancel</Button>
// //           <Button onClick={handleSubmit} variant="contained" color="primary">{editingVideo ? "Update" : "Create"}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Paper>
// //   );
// // };

// // export default VideoManagement;


// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   MenuItem,
//   Box,
//   IconButton,
//   Tooltip
// } from "@mui/material";
// import { getAllVideos, createVideo, updateVideo, deleteVideo } from "../../../services/adminService";
// import { getCategories, getSubcategories } from "../../../services/apiService";
// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// const VideoManagement = () => {
//   const [videos, setVideos] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editingVideo, setEditingVideo] = useState(null);
//   const [formData, setFormData] = useState({ title: "", videoUrl: "", category: "", subCategory: "" });
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   // Modal for playing video
//   const [openPlayer, setOpenPlayer] = useState(false);
//   const [currentVideoUrl, setCurrentVideoUrl] = useState("");

//   const fetchVideos = async () => {
//     try {
//       const data = await getAllVideos();
//       setVideos(data.data);
//     } catch (error) {
//       console.error("Error fetching videos:", error);
//     }
//   };

//   // Load categories
//   useEffect(() => {
//     fetchVideos();
//     const loadCategories = async () => {
//       try {
//         const res = await getCategories();
//         setCategories(res.data);
//       } catch (error) {
//         console.error("Error loading categories:", error);
//       }
//     };
//     loadCategories();
//   }, []);

//   // Load subcategories whenever category changes
//   useEffect(() => {
//     if (!formData.category) {
//       setSubcategories([]);
//       return;
//     }
//     const loadSubcategories = async () => {
//       try {
//         const res = await getSubcategories(formData.category);
//         setSubcategories(res.data);
//       } catch (error) {
//         console.error("Error loading subcategories:", error);
//         setSubcategories([]);
//       }
//     };
//     loadSubcategories();
//   }, [formData.category]);

//   const handleOpenDialog = (video = null) => {
//     setEditingVideo(video);
//     setFormData(video ? { ...video } : { title: "", videoUrl: "", category: "", subCategory: "" });
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setEditingVideo(null);
//     setFormData({ title: "", videoUrl: "", category: "", subCategory: "" });
//     setSubcategories([]);
//   };

// const handleSubmit = async () => {
//   if (!formData.title || !formData.videoUrl || !formData.category) {
//     alert("Please fill all required fields!");
//     return;
//   }
//   try {
//     if (editingVideo) {
//       await updateVideo(editingVideo._id, formData);
//     } else {
//       await createVideo(formData);
//     }
//     fetchVideos();
//     handleCloseDialog();
//   } catch (error) {
//     console.error("Error saving video:", error);
//   }
// };


//   const handleDelete = async (id) => {
    
//     try {
//       await deleteVideo(id);
//       fetchVideos();
//     } catch (error) {
//       console.error("Error deleting video:", error);
//     }
//   };

//   const getYouTubeId = (url) => {
//     const regExp =
//       /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = url.match(regExp);
//     return match && match[2].length === 11 ? match[2] : null;
//   };

//   const handlePlayVideo = (url) => {
//     setCurrentVideoUrl(url);
//     setOpenPlayer(true);
//   };

//   const handleClosePlayer = () => {
//     setCurrentVideoUrl("");
//     setOpenPlayer(false);
//   };

//   return (
//     <Paper style={{ padding: "1rem" }}>
//       <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>
//         Add Video
//       </Button>

//       <TableContainer>
//         <Table>
//           <TableHead>
//             <TableRow>
//                  <TableCell>Video</TableCell>
//               <TableCell>Title</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>SubCategory</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {videos.map((video) => (
//               <TableRow key={video._id}>
//                 <TableCell>
//                   {video.videoUrl.includes("youtube.com") || video.videoUrl.includes("youtu.be") ? (
//                     <img
//                       src={`https://img.youtube.com/vi/${getYouTubeId(video.videoUrl)}/0.jpg`}
//                       alt={video.title}
//                       style={{ width: "120px", cursor: "pointer", borderRadius: ".4rem"}}
//                       onClick={() => handlePlayVideo(video.videoUrl)}
//                     />
//                   ) : (
//                     <video
//                       src={video.videoUrl}
//                       width="120"
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handlePlayVideo(video.videoUrl)}
//                     />
//                   )}
//                 </TableCell>
//                 <TableCell>{video.title}</TableCell>
                
//                 <TableCell>{video.category_name}</TableCell>
//                 <TableCell>{video.subCategory_name}</TableCell>
// <TableCell>
//   <Box display="flex" gap={1}> {/* gap se buttons ke beech thoda space */}
//     <Tooltip title="Edit">
//       <IconButton color="primary" onClick={() => handleOpenDialog(video)} size="small">
//         <EditIcon fontSize="small" />
//       </IconButton>
//     </Tooltip>

//     <Tooltip title="Delete">
//       <IconButton color="error" onClick={() => handleDelete(video._id)} size="small">
//         <DeleteIcon fontSize="small" />
//       </IconButton>
//     </Tooltip>
//   </Box>
// </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Video Form Dialog */}
//       <Dialog open={openDialog} onClose={handleCloseDialog}>
//         <DialogTitle>{editingVideo ? "Edit Video" : "Add Video"}</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="Title"
//             fullWidth
//             margin="dense"
//             value={formData.title}
//             onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//           />
//           <TextField
//             label="Video URL"
//             fullWidth
//             margin="dense"
//             value={formData.videoUrl}
//             onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
//           />
//           <TextField
//             label="Category"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.category}
//             onChange={(e) => setFormData({ ...formData, category: e.target.value })}
//           >
//             {categories.map(cat => (
//               <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             label="SubCategory"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.subCategory}
//             onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
//             disabled={!formData.category}
//           >
//             {subcategories.map(sub => (
//               <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>
//             ))}
//           </TextField>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog}>Cancel</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">{editingVideo ? "Update" : "Create"}</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Video Player Modal */}
//       <Dialog open={openPlayer} onClose={handleClosePlayer} maxWidth="md" fullWidth>
//         <DialogTitle>
//           Video Player
//           <IconButton
//             aria-label="close"
//             onClick={handleClosePlayer}
//             sx={{ position: 'absolute', right: 8, top: 8 }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {currentVideoUrl.includes("youtube.com") || currentVideoUrl.includes("youtu.be") ? (
//             <iframe
//               width="100%"
//               height="400px"
            
//               src={`https://www.youtube.com/embed/${getYouTubeId(currentVideoUrl)}`}
//               title="YouTube video"
//               frameBorder="0"
//               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//             />
//           ) : (
//             <video src={currentVideoUrl} width="100%" height="400px" controls autoPlay />
//           )}
//         </DialogContent>
//       </Dialog>
//     </Paper>
//   );
// };

// export default VideoManagement;

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Box,
  IconButton,
  Tooltip
} from "@mui/material";
import { getAllVideos, createVideo, updateVideo, deleteVideo } from "../../../services/adminService";
import { getCategories, getSubcategories } from "../../../services/apiService";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const VideoManagement = () => {
  const [videos, setVideos] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingVideo, setEditingVideo] = useState(null);
  const [formData, setFormData] = useState({ title: "", videoUrl: "", category: "", subCategory: "", videoFile: null });
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  // Modal for playing video
  const [openPlayer, setOpenPlayer] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const fetchVideos = async () => {
    try {
      const data = await getAllVideos();
      setVideos(data.data);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  // Load categories
  useEffect(() => {
    fetchVideos();
    const loadCategories = async () => {
      try {
        const res = await getCategories();
        setCategories(res.data);
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    };
    loadCategories();
  }, []);

  // Load subcategories whenever category changes
  useEffect(() => {
    if (!formData.category) {
      setSubcategories([]);
      return;
    }
    const loadSubcategories = async () => {
      try {
        const res = await getSubcategories(formData.category);
        setSubcategories(res.data);
      } catch (error) {
        console.error("Error loading subcategories:", error);
        setSubcategories([]);
      }
    };
    loadSubcategories();
  }, [formData.category]);

  const handleOpenDialog = (video = null) => {
    setEditingVideo(video);
    setFormData(video ? { ...video, videoFile: null } : { title: "", videoUrl: "", category: "", subCategory: "", videoFile: null });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingVideo(null);
    setFormData({ title: "", videoUrl: "", category: "", subCategory: "", videoFile: null });
    setSubcategories([]);
  };

  const handleSubmit = async () => {
    if (!formData.title || !formData.category) {
      alert("Please fill all required fields!");
      return;
    }

    if (!formData.videoFile && !formData.videoUrl && !editingVideo) {
      alert("Please provide a video URL or upload a file!");
      return;
    }

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("category", formData.category);
      if (formData.subCategory) data.append("subCategory", formData.subCategory);

      if (formData.videoFile) {
        data.append("videoFile", formData.videoFile); // file upload
      } else if (formData.videoUrl) {
        data.append("videoUrl", formData.videoUrl); // URL
      }

      if (editingVideo) {
        await updateVideo(editingVideo._id, data);
      } else {
        await createVideo(data);
      }

      fetchVideos();
      handleCloseDialog();
    } catch (error) {
      console.error("Error saving video:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteVideo(id);
      fetchVideos();
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  const getYouTubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const handlePlayVideo = (url) => {
    setCurrentVideoUrl(url);
    setOpenPlayer(true);
  };

  const handleClosePlayer = () => {
    setCurrentVideoUrl("");
    setOpenPlayer(false);
  };

  return (
    <Paper style={{ padding: "1rem" }}>
      <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>
        Add Video
      </Button>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
                  <TableCell>#</TableCell>
              <TableCell>Video</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>SubCategory</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {videos.map((video,idx) => (
              <TableRow key={video._id}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>
                  {video.videoUrl.includes("youtube.com") || video.videoUrl.includes("youtu.be") ? (
                    <img
                      src={`https://img.youtube.com/vi/${getYouTubeId(video.videoUrl)}/0.jpg`}
                      alt={video.title}
                      style={{ width: "120px", cursor: "pointer", borderRadius: ".4rem"}}
                      onClick={() => handlePlayVideo(video.videoUrl)}
                    />
                  ) : (
                    <video
                      src={video.videoUrl}
                      width="120"
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePlayVideo(video.videoUrl)}
                    />
                  )}
                </TableCell>
                <TableCell>{video.title}</TableCell>
                <TableCell>{video.category_name}</TableCell>
                <TableCell>{video.subCategory_name}</TableCell>
                <TableCell>
                  <Box display="flex" gap={1}>
                    <Tooltip title="Edit">
                      <IconButton color="primary" onClick={() => handleOpenDialog(video)} size="small">
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete">
                      <IconButton color="error" onClick={() => handleDelete(video._id)} size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Video Form Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{editingVideo ? "Edit Video" : "Add Video"}</DialogTitle>
        <DialogContent>
  {/* Title */}
  <TextField
    label="Title"
    fullWidth
    margin="dense"
    value={formData.title}
    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
  />

  {/* Video URL */}
  <TextField
    label="Video URL"
    fullWidth
    margin="dense"
    value={formData.videoUrl}
    onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
    helperText="Either enter a URL or upload a file below"
    disabled={!!formData.videoFile} // 🔹 disable if file is selected
  />

  {/* File Upload */}
  <Box mt={2}>
    <input
      type="file"
      accept="video/*"
      onChange={(e) => setFormData({ ...formData, videoFile: e.target.files[0] })}
      disabled={!!formData.videoUrl} // 🔹 disable if URL is entered
    />
  </Box>

  {/* Category */}
  <TextField
    label="Category"
    select
    fullWidth
    margin="dense"
    value={formData.category}
    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
  >
    {categories.map(cat => (
      <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
    ))}
  </TextField>

  {/* SubCategory */}
  <TextField
    label="SubCategory"
    select
    fullWidth
    margin="dense"
    value={formData.subCategory}
    onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
    disabled={!formData.category}
  >
    {subcategories.map(sub => (
      <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>
    ))}
  </TextField>
</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">{editingVideo ? "Update" : "Create"}</Button>
        </DialogActions>
      </Dialog>

      {/* Video Player Modal */}
      <Dialog open={openPlayer} onClose={handleClosePlayer} maxWidth="md" fullWidth>
        <DialogTitle>
          Video Player
          <IconButton
            aria-label="close"
            onClick={handleClosePlayer}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {currentVideoUrl.includes("youtube.com") || currentVideoUrl.includes("youtu.be") ? (
            <iframe
              width="100%"
              height="400px"
              src={`https://www.youtube.com/embed/${getYouTubeId(currentVideoUrl)}`}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video src={currentVideoUrl} width="100%" height="400px" controls autoPlay />
          )}
        </DialogContent>
      </Dialog>
    </Paper>
  );
};

export default VideoManagement;
